<template>
    <div class="ed-range-slider-wrapper">
        <div class="ed-range-slider ed-range-slider-notanimated ed-range-slider-draggabble">
            <div class="ed-range-steps">
                <span v-for="n in steps+1" v-bind:style="{ width: percent + '%' }" v-bind:class="{ 'active-step': n == parseInt(tempvalue, 10)+1 }" v-bind:data-step="n+min-1"></span>
            </div>
            <span v-bind:style="{ width: (percent*parseInt(tempvalue, 10)) + '%' }" class="nw-slider-bar"></span>
            <span v-bind:style="{ left: (percent*parseInt(tempvalue, 10)) + '%' }" class="draggable nw-slider-dot"></span>
        </div>
        <input type="hidden" class="nw-slider-value" v-model.lazy="tempvalue" @change="valueChanged()" />
        <input type="hidden" class="nw-slider-steps" v-model="steps" />
        <div class="gesture-helpers" v-if="!valuediffer">
            <img class="hand-swipe-left" src="/material/img/gestures/hand-swipe-left.png" alt="" />
            <img class="hand-swipe-right" src="/material/img/gestures/hand-swipe-right.png" alt="" />
        </div>
        <div class="ed-range-edges">
            <span class="poll-text-content-edit first" @input="textEdit(textEditPointer + '[0].name', $event)" contenteditable="true" spellcheck="false" v-if="textEditor && textEditor.active">{{first}}</span>
            <span v-else class="first">{{first}}</span>

            <span class="poll-text-content-edit last" @input="textEdit(textEditPointer + '[1].name', $event)" contenteditable="true" spellcheck="false" v-if="textEditor && textEditor.active">{{last}}</span>
            <span v-else class="last">{{last}}</span>
        </div>
    </div>
</template>

<script>
function pauseEvent(e){
    if(e.stopPropagation) e.stopPropagation();
    if(e.preventDefault) e.preventDefault();
    e.cancelBubble=true;
    e.returnValue=false;
    return false;
}

document.addEventListener("mousemove", function(ev){
    mouseMove(ev);
});
document.addEventListener("touchmove", function(ev){
    mouseMove(ev);
});
function mouseMove(ev){
    if(dragObject != null){
        ev = ev || window.event;
        var mousePos = mouseCoords(ev);
        pauseEvent(ev);
        var new_left = mousePos.x - dragParent.left + document.body.scrollLeft - document.body.clientLeft;
        new_relative = Math.max(Math.min(100/dragParent.width*new_left, 100), 0);
        dragObject.children[2].style.left = new_relative+"%";
        dragObject.children[1].style.width = new_relative+"%";
        new_value = Math.round(get_steps/100*new_relative);
    }
}
function mouseCoords(ev){
    if(typeof ev.touches !== "undefined" && typeof ev.touches[0] !== "undefined"){
        return {x:ev.touches[0].clientX, y:ev.touches[0].clientY};
    }
    if(ev.pageX || ev.pageY){
        return {x:ev.pageX, y:ev.pageY};
    }
    return {
        x:ev.clientX + document.body.scrollLeft - document.body.clientLeft,
        y:ev.clientY + document.body.scrollTop  - document.body.clientTop
    };
}

document.addEventListener("mouseup", function(ev){
    mouseUp(ev);
});
document.addEventListener("touchend", function(ev){
    mouseUp(ev);
});
var dragObject = null;
var dragParent = null;
var dragInput = null;
var new_relative = null;
var new_value = null;
var get_steps = null;

function makeClickable(object){
    var touchDown = function(that, ev) {
        dragObject = that;
        var mousePos = mouseCoords(ev);

        dragParent = dragObject.parentElement.parentElement.getBoundingClientRect();

        dragInput = dragObject.nextElementSibling;

        get_steps = parseInt(dragObject.parentElement.children[2].value, 10);

        dragObject.classList.add("dragging");

        mouseMove(ev);
    };
    object.addEventListener("touchstart", function(ev){
        touchDown(this, ev);
    });
    object.addEventListener("mousedown", function(ev){
        touchDown(this, ev);
    });
}
function mouseUp(ev){
    if(dragObject != null){
        if(parseInt(dragInput.value, 10) == new_value){
            dragObject.children[2].style.left = (new_value*get_steps)+"%";
            dragObject.children[1].style.width = (new_value*get_steps)+"%";
        }
        dragInput.value = new_value;

        var evt = document.createEvent("HTMLEvents");
        evt.initEvent("change", false, true);

        dragInput.dispatchEvent(evt);
        new_relative = null;
        new_value = null;
        dragObject.classList.remove("dragging");
        dragObject.children[2].style.left = dragObject.children[1].style.width;
        dragObject = null;
    }
}


export default {
    props: {
        value: Number,
        min: Number,
        max: Number,
        step: Number,
        first: String,
        last: String,
        textEditor: Object,
        textEdit: Function,
        textEditPointer: String
    },

    data: function() {
        return {
            steps: 0,
            percent: 0,
            tempvalue: 0,
            valuediffer: false
        };
    },

    created: function() {
        var that = this;

        if (!this.value) {
            // this.value = Math.max(1, (this.max-this.min)/2);
            this.$emit('update:value', Math.max(1, (this.max-this.min)/2));
        }

        this.tempvalue = parseInt(this.value / this.step, 10);
        this.steps = (this.max-this.min)/this.step;
        this.percent = 100/this.steps;

        if (that.percent*parseInt(that.tempvalue, 10) !== 50) {
            this.valuediffer = true;
        }

        this.$nextTick(function() {
            var list_sliders = document.querySelector(".ed-range-slider-draggabble");
            if(typeof list_sliders === "object"){
                list_sliders.classList.remove("ed-range-slider-draggabble");
                makeClickable(list_sliders);
            }

            var r_slider = jQuery(".ed-range-slider.ed-range-slider-notanimated").eq(0).removeClass("ed-range-slider-notanimated");

            r_slider.children("span").eq(0).css({"width": "0px"}).animate({
                width: (that.percent*parseInt(that.tempvalue, 10)) + '%'
            }, 600, function() {
                // Animation complete.
            });

            r_slider.children("span").eq(1).css({"left": "0px"}).animate({
                left: (that.percent*parseInt(that.tempvalue, 10)) + '%'
            }, 600, function() {
                // Animation complete.
            });
        });
    },

    methods: {
        valueChanged: function() {
            this.valuediffer = true;
            // this.value = Math.max(1, parseInt(this.tempvalue, 10)*this.step);
            this.$emit('update:value',  Math.max(1, parseInt(this.tempvalue, 10)*this.step));
            this.$emit('changed', Math.max(1, parseInt(this.tempvalue, 10)*this.step));
        }
    }
}
</script>
